import { gsap } from "gsap";
import ScrollTrigger from 'gsap/ScrollTrigger';
import SplitText from 'gsap/SplitText';
gsap.registerPlugin(ScrollTrigger, SplitText);

import { horizontalLoop } from '../snippets/horizontalLoop'
import flipbutton from '../snippets/flipbutton'
import { onWidthResize, offWidthResize } from '../utils/resize.js';
import { eagerLoadNearView } from '../utils/eager-images.js';

export default class CollectionSlider {
    constructor(container) {
        this.container = container;

        this.wrapper = this.container.querySelector(".collection-slider__track");
        this.boxes = gsap.utils.toArray(".collection-slider__item");
        this.flipbuttons = this.container.querySelectorAll('.collection-slider__footer .js-flipbutton');

        this.title = this.container.querySelector('.collection-slider__title');
        this.text_lines = new SplitText(this.title, { type: 'lines,words', linesClass: "lineParent" });

        this.init();
    }

    init = () => {
        // Only build the draggable/looping slider when the items overflow the
        // row. With a few items they fit and stay static — no loop (which
        // misbehaves when there's nothing to scroll), no arrows, no drag.
        if (this.overflows()) {
            this.loop = horizontalLoop(this.boxes, { gap: 20, paused: false, reversed: false, draggable: true, center: false, repeat: -1 });
            this.bindControls();
        } else {
            this.container.classList.add('collection-slider--static');
        }

        eagerLoadNearView(this.container);

        gsap.fromTo(this.text_lines.words, { yPercent: 100, }, {
            yPercent: 0, duration: 0.6, stagger: { each: 0.1, ease: 'power.out', from: 'start' }, ease: 'power3.out', scrollTrigger: { trigger: this.container },
            onComplete: () => onWidthResize(this.onResize)
        });

        gsap.set(this.boxes, { opacity: 0, yPercent: 40 });
        ScrollTrigger.batch(this.boxes, {
            interval: 0.2,
            batchMax: 7,
            start: "top-=40px bottom",
            toggleActions: "play pause resume reset",
            onEnter: (element, e) => {
                gsap.to(element, { opacity: 1, yPercent: 0, duration: 1.6, delay: 0, stagger: { each: 0.1 }, overwrite: 'auto', ease: 'expo.out', });
            },
            // markers:true
        });

        this.flipbuttons.forEach(element => {
            new flipbutton(element);
        });

    }

    overflows = () => this.wrapper.scrollWidth > this.wrapper.clientWidth + 1;

    bindControls = () => {
        this.boxes.forEach((box, i) => box.addEventListener("click", () => this.loop.toIndex(i, { duration: 0.8, ease: "power1.inOut" })));
        this.container.querySelector(".collection-slider__arrow--next")?.addEventListener("click", () => this.loop.next({ duration: 0.4, ease: "power1.inOut" }));
        this.container.querySelector(".collection-slider__arrow--prev")?.addEventListener("click", () => this.loop.previous({ duration: 0.4, ease: "power1.inOut" }));
    }

    onResize = () => {
        this.text_lines.revert();
        offWidthResize(this.onResize);
    }
}

